export const init = () => {

  // TRACKER 'DELIVERY'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.funnel.delivery);

  // ProceedToPayment
  const proceedToPayment = new AnalyticsQueueEvent('proceedToPayment', tracker.defaultEvent());
  proceedToPayment.trigger = 'click';
  proceedToPayment.options.action = 'ProceedToPayment';
  proceedToPayment.domContainer = '#main-container';
  proceedToPayment.domElement = '.dkt-checkout-primary-button';
  proceedToPayment.getLabel = () => getLabelDelivery();
  tracker.addEvent(proceedToPayment);

  // OpenDeliveryMethodBox
  const changeDeliveryMethodBox = new AnalyticsTriggerEvent('changeDeliveryMethodBox', tracker.defaultEvent());
  changeDeliveryMethodBox.trigger = 'click';
  changeDeliveryMethodBox.options.action = 'changeDeliveryMethodBox';
  changeDeliveryMethodBox.domElement = '.checkout__shipping__header';
  changeDeliveryMethodBox.getAction = $element => {
    const box = $element.closest('.checkout__shipping__wrapper');
    if (box.hasClass('checkout__shipping__wrapper--deployed'))
      return 'OpenDeliveryMethodBox';
    return 'CloseDeliveryMethodBox';
  };
  changeDeliveryMethodBox.getLabel = $element => {
    if ($element.attr('data-target')) return $element.data('target').replace('#', '');
    return $element.parent().attr('id');
  };
  changeDeliveryMethodBox.stopEvent = ($element, data, jqEvent, jqData) => {
    if (jqEvent.which) return false;
    return true;
  };
  tracker.addEvent(changeDeliveryMethodBox);

  // ChangeClickCollectMethod
  const changeClickCollectMethod = new AnalyticsTriggerEvent('changeClickCollectMethod', tracker.defaultEvent());
  changeClickCollectMethod.trigger = 'click';
  changeClickCollectMethod.options.value = 1;
  changeClickCollectMethod.options.action = 'PickUpMethodSelection';
  changeClickCollectMethod.domElement = '.radio';
  changeClickCollectMethod.getLabel = function($element) {
    let div = $element.closest('div');
    div = div.length > 0 ? div[0] : div;
    if (div) {
      const previousDiv = div.previousElementSibling;
      if (previousDiv && previousDiv.nodeName) {
        if (previousDiv.nodeName === 'DIV') return 'ClicAndCollect';
      }
    }
    return 'ClicAndCollect1H';
  };
  tracker.addEvent(changeClickCollectMethod);


 	// ChangeDeliveryMethod
 	const changeDeliveryMethod = new AnalyticsTriggerEvent('changeDeliveryMethod', tracker.defaultEvent());
 	changeDeliveryMethod.trigger = 'change';
 	changeDeliveryMethod.options.action = 'ChangeDeliveryMethod';
 	changeDeliveryMethod.domContainer = '#main-container';
 	changeDeliveryMethod.domElement = '.checkout__shipping__input';
 	changeDeliveryMethod.getLabel = () => getLabelDelivery();
 	tracker.addEvent(changeDeliveryMethod);

 	// OpenMyLocationStoreList
 	const openMyLocationStoreList = new AnalyticsTriggerEvent('openMyLocationStoreList', tracker.defaultEvent());
 	openMyLocationStoreList.trigger = 'click';
 	openMyLocationStoreList.options.action = 'OpenMyLocationStoreList';
 	openMyLocationStoreList.options.label = '';
 	openMyLocationStoreList.domElement = '.delivery-location button#dropdown';
 	openMyLocationStoreList.stopEvent = $element => ($element.siblings('#result-layout-location').is(':visible'));
 	tracker.addEvent(openMyLocationStoreList);

 	// ChangeNameForPickUp
 	const changeNameForPickUp = new AnalyticsTriggerEvent('changeNameForPickUp', tracker.defaultEvent());
 	changeNameForPickUp.trigger = 'blur';
 	changeNameForPickUp.options.action = 'ChangeNameForPickUp';
 	changeNameForPickUp.domElement = '.js-pickup-friend-name';
 	changeNameForPickUp.options.label = '';
 	tracker.addEvent(changeNameForPickUp);

 	// ViewMoreStore
 	const viewMoreStore = new AnalyticsClickEvent('viewMoreStore', tracker.defaultEvent());
 	viewMoreStore.options.action = 'ViewMoreStore';
 	viewMoreStore.domElement = '#js-more-stores';
 	viewMoreStore.options.label = '';
 	tracker.addEvent(viewMoreStore);


  // Common method
  // %DELIVERY_METHOD% + %DELIVERY_METHOD_NAME%
  const getLabelDelivery = () => {

    let deliveryMethod = '';
    let deliveryMethodName = '';
    const concat = AnalyticsConstants.concatenator;
    const selectedRadio = $('input[name="delivery-type"]:checked');

    if (selectedRadio) {
      if (
        selectedRadio.closest('.checkout__shipping__wrapper') &&
        selectedRadio.closest('.checkout__shipping__wrapper').attr('id')
      ) {
        // Get delivery METHOD from the input's closest wrapper ID
        deliveryMethod = selectedRadio
          .closest('.checkout__shipping__wrapper')
          .attr('id');
        // Concat the STORE ID to the delivery method in case of pickup
        if (deliveryMethod === 'pick-up')
          deliveryMethod += concat + selectedRadio.val();
      }

      if (
        selectedRadio.next('label') &&
        selectedRadio.next('label').find('span')
      ) {
        // Get the delivery method's NAME
        const deliveryMethodNameElt = selectedRadio
          .next('label')
          .find('span')
          .clone();
        if (deliveryMethodNameElt.find('em')) {
          // Remove <em> if any (usually duplicate of the Store Name)
          deliveryMethodNameElt.find('em').remove();

          deliveryMethodName += deliveryMethodNameElt.text().trim();
        }
      }
    }

    return deliveryMethod + concat + deliveryMethodName;
  };

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};




// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/delivery-tracker.js